// All comments in English.
export default function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center p-8 text-gray-600">
      <svg className="h-6 w-6 animate-spin" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
      </svg>
      <span className="ml-2 text-sm">Loading...</span>
    </div>
  );
}
